import React, { Component, Fragment, createRef } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import Golf from '../../../../../models/Golf.js';
import { withTranslation } from "react-i18next";
import { Dropdown, Icon, Menu, Popconfirm, Rate, Tooltip } from 'antd';
import Ripple from '../../../common/component/Ripple';
import Modal from '../../../common/component/Modal';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
import { DndProvider, DragSource, DropTarget } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";

const ListCols = ['orderNo', 'name', 'code', 'active','translations'];
const ModelFields = Object.getOwnPropertyNames(new Golf());

// Định nghĩa type cho dnd
const type = "DraggableBodyRow";

// Source: Từ đâu kéo
const rowSource = {
    beginDrag(props) {
        return { index: props.index };
    },
};

// Target: Kéo đến đâu
const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        if (dragIndex === hoverIndex) return;

        props.moveRow(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },
};

// Tạo component row có thể kéo thả
class DraggableBodyRow extends Component {
    ref = createRef();

    render() {
        const {
            isOver,
            isDragging,
            connectDragSource,
            connectDropTarget,
            moveRow,
            className,
            style,
            ...restProps
        } = this.props;

        const rowStyle = {
            cursor: "move",
            ...style,
        };

        return connectDragSource(
            connectDropTarget(
                <tr
                    ref={this.ref}
                    className={className}
                    style={rowStyle}
                    {...restProps}
                />
            )
        );
    }
}

// Wrap component với HOC DragSource và DropTarget
const DraggableRow = DropTarget(type, rowTarget, (connect) => ({
    connectDropTarget: connect.dropTarget(),
}))(
    DragSource(type, rowSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    }))(DraggableBodyRow)
);

class GolfList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                orderNo: {
                    width: 100,
                    key: 'orderNo',
                    render: (text, record) => {
                        return (
                            <div
                                style={{
                                    cursor: "move",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "30px",
                                }}
                            >
                                <Icon type="menu" /> {Number(record.orderNo)}
                            </div>
                        );
                    },
                },
                name: {
                    width: 220,
                    key: 'name',
                    align: 'center',
                },
                code: {
                    width: 100,
                    key: 'code',
                    align: 'left',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                
                active: {
                    width: 100,
                    key: 'active',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.homestay.active') : this.props.t('item.homestay.deActive')} />
                    )
                },
                translations: {
                    key: 'translations',
                    width: 100,
                    render: (text, record) => {
                        // Xử lý dữ liệu translations dựa trên cấu trúc trong ảnh
                        const translations = [];
                        
                        // Chuyển đổi các mục trong translations từ API để phù hợp với component FlagIcons
                        if (record.translations && Array.isArray(record.translations)) {
                            record.translations.forEach(trans => {
                                if (trans.languageCode) {
                                    translations.push({
                                        languageCode: trans.languageCode,
                                        name: trans.name,
                                        isDefault: trans.isDefault,
                                    });
                                }
                            });
                        }
                        
                        return <FlagIcons languages={translations.length > 0 ? translations : (record.languages || [])} />;
                    },
                },
                action: {
                    // fixed: 'right',
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
            syncGolfId: ''
        };
    }

    // Cấu hình component cho table
    components = {
        body: {
            row: DraggableRow,
        },
    };

    
    moveRow = (dragIndex, hoverIndex) => {
        const { golf } = this.props;
        const dragRow = golf[dragIndex];
        
        // Update new data in order of change
        const newData = [...golf];
        // Delete element at dragIndex
        newData.splice(dragIndex, 1);
        // Insert at hoverIndex position
        newData.splice(hoverIndex, 0, dragRow);
        
        const dataWillBeSent = {
            data: newData.map((item, index) => ({
                id: item.id,
                orderNo: index,
            }))
        };
        
        // Call action to update order
        this.props.updateGolfOrder(dataWillBeSent);

    };

    static getDerivedStateFromProps(nextProps, prevState){
        if((nextProps.isFetchSync !== prevState.isFetchSync) && !nextProps.isFetchSync ){
           return { syncGolfId: '' };
       }
       else return null;
     }

    render() {
        const { loading, pagination, golf } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <DndProvider backend={HTML5Backend} key={Math.random()}>
                <ListComponent
                    tableKey="golf-list"
                    // scroll={{ x: 1300 }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: loading, size: 'large' }}
                    dataSource={Func.getDataSource(golf || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'golf'
                    })}
                    onChange={this.props.onChange}
                    pagination={{ 
                        total: pagination.totalCount, 
                        totalPage: pagination.totalPage, 
                        defaultCurrent: pagination.defaultCurrent, 
                        defaultPageSize: pagination.pageSize 
                    }}
                    componentTableList={{}}
                    classChildren="p-0" classParent="m-0"
                    components={this.components}
                    onRow={(record, index) => ({
                        index,
                        moveRow: this.moveRow,
                        record,
                    })}
                />
            </DndProvider>
        );
    }

    handleSync = (golfId) => {
        this.setState({ syncGolfId: golfId })
        this.props.syncGolf(golfId)
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeAirport = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.airport.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeAirport,
            });
        };
        return (
            <Fragment>
                <Link to={Func.getPathWithParams(PATHS.GOLF_COURSE.DETAIL.path, { id: item.id })} className={`mr-2`}>
                    <Icon type="form" className="fs20 mr-1" />
                </Link>
            </Fragment>
        )
    }


}

export default withTranslation()(GolfList);
